import {
  UPDATE_FILE_UPLOAD_PROGRESS,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILED,
  RESET_FILE_UPLOAD_FAILED,
  RESET_FILE_UPLOAD_PROGRESS,
  UPDATE_FILE_INFORMATION_SUCCESS,
  DOWNLOAD_FILE_FAILED
} from './FilesConstants';
import { getFileTypeCategory, PLAIN_TEXT_FILE, UNKNOWN_FILE, convertFileToDownload } from 'shared/helpers/fileTransferHelper';
import { fetchImportMappingDataSuccess, resetImportMappingDataSuccess, updateContainerList } from '../mapping/MappingActions';
import axios from 'axios';

const updateFileUploadProgress = (loaded, total) => ({ type: UPDATE_FILE_UPLOAD_PROGRESS, loaded, total });
const resetFileUploadProgress = () => ({ type: RESET_FILE_UPLOAD_PROGRESS });
const resetFileUploadFailed = () => ({ type: RESET_FILE_UPLOAD_FAILED });
const uploadFileSuccess = () => ({ type: UPLOAD_FILE_SUCCESS });
const uploadFileFailed = errorMessage => ({ type: UPLOAD_FILE_FAILED , errorMessage});
const downloadFileFailed = errorMessage => ({ type: DOWNLOAD_FILE_FAILED , errorMessage});
const updateFileInformationSuccess = fileInformation => ({ type: UPDATE_FILE_INFORMATION_SUCCESS, fileInformation });

const getFormDataObject = (files, additionalInformation) => {
  const formData = new FormData();
  files.forEach(file => {
    formData.append("file", file);
  });
  if (additionalInformation) {
    Object.keys(additionalInformation).forEach(key =>
      formData.append(key, additionalInformation[key])
    );
  }
  return formData;
};

const uploadFiles = ({ files, additionalInformation, url, onComplete }) => dispatch => {
  const onUploadProgress = ({lengthComputable, loaded, total}) => (lengthComputable) ? dispatch(updateFileUploadProgress(loaded, total)) : null;
  axios
    .post(`${url}`, getFormDataObject(files, additionalInformation), {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${files._boundary}`,
        jwtToken: window.sessionStorage.getItem("jwtToken")
      },
      onUploadProgress
    })
    .then(response => {
      switch (response.data.status) {
        case 200:
          if (!response.errMsg) {
            dispatch(uploadFileSuccess());
            onComplete ? onComplete(response.data.data) : '';
          } else {
            dispatch(uploadFileFailed("The file is unable to be saved due to an error. Please review"));
          }
          break;
        case 400:
          dispatch(uploadFileFailed(response.data.errors[0].message));
          dispatch(resetFileUploadProgress());
          break;
        default:
          dispatch(uploadFileFailed("The file is unable to be saved due to an error. Please review"));
          dispatch(resetFileUploadProgress());
          break;
      }
    });
};

const downloadFile = ({ file, url, onComplete }) => dispatch => {
  axios({
    method: 'get',
    url: `${url}`,
    responseType: 'blob',
    headers: { jwtToken: window.sessionStorage.getItem('jwtToken') }
  }).then(response => {
    switch (response.status) {
      case 200:
        if (!response.errMsg) {
          convertFileToDownload(response, file.name);
          onComplete ? onComplete(response) : '';
        } else {
          dispatch(
            downloadFileFailed(
              'The file is unable to be retrieved due to an error. Please review'
            )
          );
        }
        break;
      case 400:
        dispatch(downloadFileFailed(response.errors[0].message));
        break;
      default:
        dispatch(
          downloadFileFailed(
            'The file is unable to be retrieved due to an error. Please review'
          )
        );
        break;
    }
  });
};

const exportFile = ({ file, url, onComplete, body }) => dispatch => {
  axios({
    method: 'post',
    url: `${url}`,
    data: body,
    responseType: 'blob',
    headers: { jwtToken: window.sessionStorage.getItem('jwtToken') }
  }).then(response => {
    switch (response.status) {
      case 200:
        if (!response.errMsg) {
          convertFileToDownload(response, file);
          onComplete ? onComplete(response) : '';
        } else {
          dispatch(
            downloadFileFailed(
              'The file is unable to be retrieved due to an error. Please review'
            )
          );
        }
        break;
      case 400:
        dispatch(downloadFileFailed(response.errors[0].message));
        break;
      default:
        dispatch(
          downloadFileFailed(
            'The file is unable to be retrieved due to an error. Please review'
          )
        );
        break;
    }
  });
};

const getFileMappingInfo = requestConf => dispatch => {
  const onCompleteUpload = mapInfo => dispatch(fetchImportMappingDataSuccess(mapInfo));
  requestConf.onComplete = onCompleteUpload;
  uploadFiles(requestConf)(dispatch);
};

const updateFileInformation = fileInformation => dispatch => {
  const fileType = getFileTypeCategory(fileInformation.fileExtension);
  switch (fileType) {
    case PLAIN_TEXT_FILE:
      dispatch(updateContainerList([fileInformation.fileName]));
      break;
    case UNKNOWN_FILE:
      dispatch(updateContainerList([]));
  }
  if (!fileInformation.fileName) {
    dispatch(resetImportMappingDataSuccess(""));
  }
  dispatch(updateFileInformationSuccess(fileInformation));
};

export {
  uploadFiles,
  getFileMappingInfo,
  updateFileInformation,
  downloadFile,
  getFormDataObject,
  resetFileUploadFailed,
  exportFile
};



// WEBPACK FOOTER //
// ./src/redux/files/FilesActions.js